<div class="learning-hub-viewer-container">
  <div class="viewer-content">
    <iframe
      [src]="axonifyUrl"
      class="learning-hub-iframe"
      frameborder="0"
      title="Axonify Learning Hub"
      allow="autoplay; fullscreen; microphone; camera"
    ></iframe>
  </div>
</div>
